/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const catalogEntryListCompareCollectorBarSX: SxProps = {
	width: 'inherit',
	cursor: 'pointer',
	backgroundColor: 'rgba(0, 0, 0, 0.7)',
	'div.MuiGrid-item': {
		display: 'flex',
		alignItems: 'center',
	},
};
